// extracted by mini-css-extract-plugin
export var infoItem = "_ri-2";
export var title = "_ri-0";
export var value = "_ri-1";